import React from 'react';
import styles from "./reviewSection.module.sass"
import line from "../../assets/Line 16.png"
import gis from "../../assets/gis.png"
import {Comment} from "./components/Comment";
import {SLide} from "./components/Slide";



export const ReviewSection = () => {
    const slides = [
        <SLide></SLide>
    ];
    return (
        <div className={styles.section__review__wrap} id='sectionReview'>
            <div>
                <span className={styles.section__review__header}>Что о нас говорят</span>
            </div>
            <img className={styles.section__review__lineImg} src={line} alt=""/>
            <img className={styles.section__review__gisImg} src={gis} alt=""/>
            <div className={styles.section__review__SliderWrap}>
                <SLide></SLide>
            </div>
            <div className={styles.section__review__buttonWrap}>
                <a className={styles.section__review__button} href="https://2gis.ru/ufa/firm/2393065583174717/tab/reviews" target='_blank'>
                    <button ><span className={styles.section__review__buttonText}>ВСЕ ОТЗЫВЫ</span></button>
                </a>
            </div>
        </div>
    );
};